import {FloorplanSpotlight} from "../data/Floorplan";
import {get} from "@renaissancerentals/renaissance-component";


export const getFeaturedFloorplans = async (): Promise<FloorplanSpotlight[]> => {

    let response = await get("floorplans/search/byFeaturedOnMain?projection=spotlight&size=200");
    return await response.data._embedded.floorplans.filter((floorplan: FloorplanSpotlight) => floorplan.property.active);
};
